module.exports = __webpack_public_path__ + "static/img/ro手写声明.1191d5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/ro手写声明.jpg
// module id = 5zkf
// module chunks = 1